export {
    formComplaint
};
const formComplaint = () => {
    (function($) {
        const Form = {
            $form: $('form#main-form'),
            $selects2: null,
            $radioComplaintType: null,
            $elsProOnly: null,
            $addressFieldsUl: null,
            $contactFieldsUl: null,
            $societyFieldset: null,
            $selectPostcode: null,
            $inputCity: null,
            $inputProvince: null,
            init: function() {
                if (this.$form.length == 0) return;
                this.$selects2 = this.$form.find('.select2');
                this.$radioComplaintType = this.$form.find('input[name="complaint-type"]');
                this.$elsProOnly = this.$form.find('.only-pro');
                this.$addressFieldsUl = this.$form.find('#address-fields');
                this.$contactFieldsUl = this.$form.find('#contact-fields');
                this.$societyFieldset = this.$form.find('fieldset.society-fields');
                this.$selectPostcode = this.$form.find('select#postcode');
                this.$inputCity = this.$form.find('input#city');
                this.$inputProvince = this.$form.find('input#province');
                this.initSelect2(this.$selects2);
                this.initSelectComplaintType();
                this.initSelectPostcode();
                this.initInputFile();
                this.initCountMax();
                this.initValidation();
                this.redirect();
            },
            initSelect2: function($elements) {
                $elements.each(function() {
                    let $el = $(this);
                    if ($el.hasClass('select2-hidden-accessible')) {
                        return;
                    }
                    $el.select2({
                        minimumResultsForSearch: -1,
                        width: '100%'
                    });
                    $el.on('select2:select', function(e) {
                        $(this).valid();
                    });
                });
            },
            initSelectComplaintType: function() {
                this.$radioComplaintType.on('change', function(e) {
                    let type = $(this).val()
                    Form.switchLabelsForComplaintType();
                    if (type == 'pro') {
                        Form.$addressFieldsUl.appendTo(Form.$societyFieldset);
                        Form.$elsProOnly.slideDown();
                    } else {
                        Form.$elsProOnly.slideUp();
                        Form.$addressFieldsUl.insertAfter(Form.$contactFieldsUl);
                    }
                    // var data = e.params.data;
                    // Form.$inputCity.val(data.city);
                    // Form.$inputProvince.val(data.province);
                    // $(this).find('option:selected').val(data.postcode); // changement de la valeur après sélection pour n'avoir que le CP envoyé                    
                });
            },
            switchLabelsForComplaintType: function() {
                let $labelsToChange = this.$form.find("*[data-label-pro]");
                $labelsToChange.each(function() {
                    let $el = $(this);
                    let textAlt = $el.data('label-pro');
                    let oldText = $el.text();
                    $el.text(textAlt);
                    $el.data('label-pro', oldText);
                });
            },
            initSelectPostcode: function() {
                let textInputTooShort = this.$selectPostcode.find('option').first().text();
                this.$selectPostcode.select2({
                    width: '100%',
                    placeholder: textInputTooShort,
                    // closeOnSelect: false,                
                    minimumInputLength: 3, // only start searching when the user has input 3 or more characters,               
                    templateSelection: Form.selectPostcodeFormatter,
                    language: {
                        // You can find all of the options in the language files provided in the
                        // build. They all must be functions that return the string that should be
                        // displayed.
                        inputTooShort: function() {
                            return textInputTooShort;
                        }
                    },
                    // templateResult: Form.selectPostcodeFormatter,
                    ajax: {
                        url: vars.ajaxURL,
                        dataType: 'json',
                        delay: 300,
                        data: function(params) {
                            var query = {
                                search: params.term,
                                action: 'get_postcodes'
                            }
                            return query;
                        },
                        processResults: function(data) {
                            // Transforms the top-level key of the response object from 'items' to 'results'                            
                            return {
                                results: data
                            };
                        }
                    },
                });
                this.$selectPostcode.on("select2:open", () => {
                    document.querySelector(".select2-container--open .select2-search__field").focus()
                })
                this.$selectPostcode.on('select2:select', function(e) {
                    var data = e.params.data;
                    Form.$inputCity.val(data.city);
                    Form.$inputProvince.val(data.province);
                    $(this).find('option:selected').val(data.postcode); // changement de la valeur après sélection pour n'avoir que le CP envoyé   
                    $(this).valid();
                    Form.$inputCity.valid();
                    Form.$inputProvince.valid();
                });
            },
            initInputFile: function() {
                $('.wpcf7-file').each(function() {
                    let $input = $(this);
                    $input.on('change', function() {
                        var i = $(this).prev('label').clone();
                        var filename = $input[0].files[0].name;
                        $(this).closest('.field').find('.filename').text(filename);
                    });
                });
            },
            initCountMax: function() {
                Form.$form.find('.count-max').each(function() {
                    let $input = $(this);
                    let max = $input.attr('maxlength');
                    let $countSpan = $('<span class="count">' + $input.val().length + '</span>');
                    let $el = $('<div class="count-wrapper">/<span class="count-on">' + max + '</span></div>');
                    $el.prepend($countSpan);
                    $el.insertAfter($input);
                    $input.on('change keyup keydown', function() {
                        $countSpan.text($input.val().length);
                    });
                });
            },
            selectPostcodeFormatter: function(data) {
                if (data.postcode === undefined) {
                    return data.text;
                }
                return data.postcode;
            },
            initValidation: function() {
                Form.mobilePhoneField();
                let rules = [];
                Form.$form.find('.wpcf7-validates-as-required').each(function() {
                    let name = $(this).attr('name');
                    let type = $(this).attr('type');
                    if (name !== undefined) {
                        rules[name] = {
                            required: true,
                        };
                    }
                });
                Form.$form.validate({
                    onfocusout: function(element) { // ADD VALIDATION ON BLUR
                        this.element(element);
                    },
                    validClass: 'validation-success',
                    errorClass: 'validation-error',
                    ignore: "#gsm",
                    rules: rules
                });
                $('.wpcf7-form-control.wpcf7-submit').click(function(e) {
                    // console.log(Form.$form.validate());
                    if (!Form.$form.valid()) {
                        e.preventDefault();
                        let $firstErrorPosition = $('.wpcf7-form-control.validation-error').offset().top;
                        $firstErrorPosition = parseInt($firstErrorPosition) - 100;
                        $('body, html').animate({
                            scrollTop: $firstErrorPosition
                        }, 600);
                    }
                });
            },
            mobilePhoneField: function() {
                if ($('#gsm').length > 0) {
                    let $inputMobilePhone = $('#gsm');
                    let $wrapperInputBillingPhone = $inputMobilePhone.closest('.woocommerce-input-wrapper');
                    let inputBillingPhone = $('#gsm')[0];
                    let iti = window.intlTelInput(inputBillingPhone, {
                        preferredCountries: ['be', 'fr', 'lu', 'nl', 'gb'],
                        hiddenInput: 'gsm',
                        separateDialCode: true,
                        nationalMode: true,
                    });
                    let $validationLabel = $("<label class='validation-error'></label>");
                    //let $validLabel = $("<div class='validation-msg valid-msg hide'><i class='fas fa-check-circle'></i></div>");
                    $validationLabel.insertAfter($inputMobilePhone);
                    // $validLabel.appendTo($wrapperInputBillingPhone);
                    let reset = function() {
                        $inputMobilePhone.removeClass("validation-error").removeClass("validation-success");
                    };
                    let checkInputBillingPhone = function() {
                        reset();
                        if (inputBillingPhone.value.trim()) {
                            if (iti.isValidNumber()) {
                                $inputMobilePhone.removeClass("validation-error").addClass("validation-success");
                                return true;
                            } else {
                                $inputMobilePhone.removeClass("validation-success").addClass("validation-error");
                                let errorCode = iti.getValidationError();
                                if (errorCode == -99) {
                                    errorCode = 0;
                                }
                                let errorMsg = $inputMobilePhone.data('msg-valid-' + errorCode);
                                return false;
                            }
                        }
                    };
                    // on blur: validate
                    inputBillingPhone.addEventListener('blur', checkInputBillingPhone);
                    // on keyup / change flag: reset
                    inputBillingPhone.addEventListener('change', reset);
                    inputBillingPhone.addEventListener('keyup', reset);
                    $('.wpcf7-form-control.wpcf7-submit').click(function(e) {
                        if (inputBillingPhone.value && !iti.isValidNumber()) {
                            e.preventDefault();
                            let $firstErrorPosition = $('.wpcf7-form-control.validation-error').offset().top;
                            $firstErrorPosition = parseInt($firstErrorPosition) - 100;
                            $('body, html').animate({
                                scrollTop: $firstErrorPosition
                            }, 600);
                        }
                    });
                }
            },
            redirect: function() {
                document.addEventListener('wpcf7mailsent', function(event) {
                    var form = $('<form action="' + vars.thankyou_url + '" method="post">' + '<input type="text" name="hash" value="' + event.detail.apiResponse.posted_data_hash + '" />' + '</form>');
                    $('body').append(form);
                    form.submit();
                    //location = vars.thankyou_url;
                }, false);
            },
        }
        Form.init();
    })(jQuery);
};